import {
  APP_SETTING_DELETE_LOCALIZATION_CONFIG_BEGIN,
  APP_SETTING_DELETE_LOCALIZATION_CONFIG_SUCCESS,
  APP_SETTING_DELETE_LOCALIZATION_CONFIG_FAILURE,
  APP_SETTING_DELETE_LOCALIZATION_CONFIG_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function deleteLocalizationConfig(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_DELETE_LOCALIZATION_CONFIG_BEGIN,
    });
    const { projectId, uuid } = args;
    const promise = new Promise((resolve, reject) => {
      const header = builderSurfaceJsonContentHeader(projectId);
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}localization/${uuid}`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: APP_SETTING_DELETE_LOCALIZATION_CONFIG_SUCCESS,
              data: res.data,
              uuid: args.uuid,
            });
            toast.success('Deleted Successfully !', {});
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_DELETE_LOCALIZATION_CONFIG_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_DELETE_LOCALIZATION_CONFIG_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}
export function dismissDeleteLocalizationConfigError() {
  return {
    type: APP_SETTING_DELETE_LOCALIZATION_CONFIG_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_DELETE_LOCALIZATION_CONFIG_BEGIN:
      return {
        ...state,
        deleteLocalizationConfigPending: true,
        deleteLocalizationConfigError: null,
      };

    case APP_SETTING_DELETE_LOCALIZATION_CONFIG_SUCCESS:
      const localization = state.localization.filter((local) => local.uuid !== action.uuid);
      return {
        ...state,
        deleteLocalizationConfigPending: false,
        deleteLocalizationConfigError: null,
        localization,
      };

    case APP_SETTING_DELETE_LOCALIZATION_CONFIG_FAILURE:
      return {
        ...state,
        deleteLocalizationConfigPending: false,
        deleteLocalizationConfigError: action.data.error,
      };

    case APP_SETTING_DELETE_LOCALIZATION_CONFIG_DISMISS_ERROR:
      return {
        ...state,
        deleteLocalizationConfigError: null,
      };

    default:
      return state;
  }
}
